export enum DemoAccountType {
  NATURAL_CYCLE_MONITORING_AND_TIMED_INTERCOURSE = 'NATURAL_CYCLE_MONITORING_AND_TIMED_INTERCOURSE',
  TIMED_INTERCOURSE_CYCLE_WITH_CLOMID = 'TIMED_INTERCOURSE_CYCLE_WITH_CLOMID',
  TIMED_INTERCOURSE_CYCLE_WITH_LETROZOLE = 'TIMED_INTERCOURSE_CYCLE_WITH_LETROZOLE',
  NATURAL_CYCLE_IUI_WITH_CLOMID_OR_LETROZOLE = 'NATURAL_CYCLE_IUI_WITH_CLOMID_OR_LETROZOLE',
  NATURAL_OR_MODIFIED_NATURAL_FROZEN_EMBRYO_TRANSFER = 'NATURAL_OR_MODIFIED_NATURAL_FROZEN_EMBRYO_TRANSFER',
  LUPRON_TRIGGER_SHOT_MONITORING = 'LUPRON_TRIGGER_SHOT_MONITORING',
  PERIMENOPAUSE_REGULAR_CYCLES = 'PERIMENOPAUSE_REGULAR_CYCLES',
  PERIMENOPAUSE_NO_CYCLES = 'PERIMENOPAUSE_NO_CYCLES',
  PERIMENOPAUSE_HRT = 'PERIMENOPAUSE_HRT',
  HORMONE_OPTIMIZATION_SLEEP_DISTURBANCES = 'HORMONE_OPTIMIZATION_SLEEP_DISTURBANCES',
  HORMONE_OPTIMIZATION_MIGRAINES = 'HORMONE_OPTIMIZATION_MIGRAINES',
}
